import * as React from 'react';
import Toolbar from '@mui/material/Toolbar';
import theme from 'config/theme';
import styles from './footer.style';
import { UserMenu } from '../UserMenu';

const Footer = ({ open }) => {
  return (
    <Toolbar
      sx={{
        ...styles.toolbar,
        bottom: 0,
        top: 'unset',
        width: open
          ? theme.customValues.drawerWidth
          : theme.customValues.closedDrawerWidth,
        [theme.breakpoints.down('md')]: {
          position: open ? 'fixed' : 'initial',
          bottom: open ? '0' : 'unset',
        },
      }}
    >
      <UserMenu open={open} />
    </Toolbar>
  );
};

export default Footer;
